import PropTypes from 'prop-types';
import React from 'react';
import { withTranslation } from 'react-i18next';
import { Button, H3 } from '@blueprintjs/core';


class History extends React.PureComponent {
 
  render() {
    const { queryHistory, t } = this.props;
    
    const oldResults = queryHistory.map( (item,index) => (
      <li key={index}>
        {item.id} :&nbsp;
        <Button onClick={()=>{ this.props.handleLoadOldQuery(item.id)}} style={{color:'#106ba3'}}>
          {item.name}
        </Button>
        &nbsp;
        <Button icon ="delete" onClick={()=>{ this.props.handleDelOldQuery(index)}} />
          
      </li>
    ));

    return (
      <>
        <div className="margin-bottom-1-5-rem">
          <H3>{t('queryHistory')}</H3>
          { queryHistory.length>0 && 
            <>
              <ul>{oldResults}</ul>
              <br/>
              <center><Button onClick={this.props.handleClearResults}>{t('clearHistory')}</Button></center>
            </>
          }
          { queryHistory.length===0 && 
            <p>{t('historyIsEmpty')}</p>
          }

        </div>
      </>
    );
  }
}

History.propTypes = {
  handleLoadOldQuery: PropTypes.func,
  handleDelOldQuery: PropTypes.func,
  handleClearResults: PropTypes.func,
  queryHistory: PropTypes.array,
};

export default withTranslation()(History);
